import { render } from "./searchAutosuggest.vue?vue&type=template&id=e1251e52"
import script from "./searchAutosuggest.vue?vue&type=script&lang=js"
export * from "./searchAutosuggest.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__